import QRCode from "qrcode.react"
export default QRCode